import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

export const furtherResources = [
    {
        id: 'newsBriefs',
        icon: PictureAsPdfIcon,
        title: 'News Briefs',
        description:
            'Bi-Monthly News Briefs with global, continent and country overviews',
        url:
            'https://insecurityinsight.org/iiarchive?category=Attacks%20on%20Health%20Care%20News%20Brief',
    },
    {
        id: 'healthCareReports',
        icon: PictureAsPdfIcon,
        title: 'Health Care Reports',
        description: 'Larger archive including in-depth country reports',
        url:
            'https://insecurityinsight.org/iiarchive?category=Attacks%20on%20Health%20Care',
    },
    {
        id: 'SHCCReports',
        icon: PictureAsPdfIcon,
        title: 'SHCC Reports',
        description:
            'Yearly global reports by the Safeguarding Health in Conflict Coalition',
        url: 'https://insecurityinsight.org/iiarchive?category=shccreportsen',
    },
];
